var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-tree-container"},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.data,"show-checkbox":"","default-expand-all":"","node-key":"id","highlight-current":"","props":_vm.defaultProps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }